import slugify from "slugify";

import { TastingNote } from "../../types";
import { VinoDataWine } from "../../types/vino-data-types";

export const tastingNotesFromVinoDataWine = (
  wine: VinoDataWine
): Array<TastingNote> => {
  const { tastes, texture, intensity, palateWeight } = wine;

  let _tastes = tastes ? tastes : [];
  if (tastes && tastes.indexOf("Unavailable") > -1) _tastes = [];

  return [..._tastes, palateWeight, texture, intensity].map((item) => ({
    label: item || "citrus",
    iconName: slugify(item || "citrus", { lower: true }),
  }));
};
